import { useMutation } from "@tanstack/react-query";

import { queryClient } from "../../../../services";
import { fetchSelectedSchoolQueryOptions } from "../school-selection/queries";
import { putMySchoolInfo as putMySchoolInfoClientFn } from "./client";

export function useUpdateMySchoolInfo() {
  return useMutation({
    mutationFn: putMySchoolInfoClientFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: fetchSelectedSchoolQueryOptions().queryKey
      });
    }
  });
}

export function putMySchoolInfo(schoolId: string | undefined) {
  return putMySchoolInfoClientFn(schoolId).then(() => {
    queryClient.invalidateQueries({
      queryKey: fetchSelectedSchoolQueryOptions().queryKey
    });
  });
}
